// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3_jQ9","validationTips":"StatementDescriptor_validationTips__2xrLc"};